import { render, staticRenderFns } from "./object-expansion-editor.vue?vue&type=template&id=104c4d16"
import script from "./object-expansion-editor.vue?vue&type=script&lang=ts"
export * from "./object-expansion-editor.vue?vue&type=script&lang=ts"
import style0 from "./object-expansion-editor.vue?vue&type=style&index=0&id=104c4d16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports